import { FeatureBadge } from "@components/FeatureBadge";
import Button, { ButtonShade } from "@components/library/Button";
import { ArrowRightIcon } from "@heroicons/react/outline";
import React from "react";

interface FeatureProps {
  Icon: React.FunctionComponent<React.ComponentProps<"svg">>;
  name: string;
  title: string;
  description: string;
  list: string[];
  Image: (props: { alt: string; className: string }) => JSX.Element;
  imageAlt: string;
  buttons?: React.ReactNode;
  getStarted?: boolean;
  learnMoreLink?: string;
}

export const Feature = ({
  Icon,
  name,
  title,
  description,
  list,
  Image,
  imageAlt,
  buttons,
  getStarted,
  learnMoreLink,
}: FeatureProps) => {
  const handleScrollToCTA = () => {
    document
      ?.getElementById("main-cta")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  return (
    <div className="container-lg grid-12 pt-[108px] pb-80">
      <div className="col-span-full md:col-span-6">
        <div className="flex flex-col gap-12">
          <FeatureBadge>
            <Icon className="h-20 w-20" />
            {name}
          </FeatureBadge>
          <h3 className="max-w-lg items-center font-display text-32-36 font-bold">
            {title}
          </h3>
          <div className="mt-24 flex flex-col gap-20 text-gray-800 md:max-w-[420px]">
            <p className="text-16-24 md:text-18-28 ">{description}</p>
            <ul className="ml-20 list-outside list-disc space-y-8 text-16-24 font-bold  text-gray-800 marker:text-[20px] marker:text-gray-700">
              {list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="mt-32 flex gap-8">
              {buttons}
              {getStarted && (
                <Button
                  styling="solid"
                  onClick={handleScrollToCTA}
                  shade={ButtonShade.Gray}
                >
                  Get started
                </Button>
              )}
              {learnMoreLink && (
                <Button IconRight={ArrowRightIcon} styling="ghost">
                  Learn more
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-full pt-40 md:col-span-6 md:pt-0">
        <Image className="w-full" alt={imageAlt} />
      </div>
    </div>
  );
};
